const IDLE_TIMEOUT = 30 * 60 * 1000; // 30 minutes in ms

export const mouseIdle = {
  data() {
    return {
      mouseIdleTimer: null,
      isMouseIdle: false
    };
  },
  methods: {
    resetMouseIdleTimer() {
      this.isMouseIdle = false;
      if (this.mouseIdleTimer) {
        clearTimeout(this.mouseIdleTimer);
      }
      this.mouseIdleTimer = setTimeout(() => {
        this.isMouseIdle = true;
        this.onMouseIdle();
      }, IDLE_TIMEOUT);
    },
    onMouseIdle() {
      // Override this method in the component to handle idle event
      console.log('您已经30分钟没有操作了');
    }
  },
  mounted() {
    document.addEventListener('mousemove', this.resetMouseIdleTimer);
    document.addEventListener('keydown', this.resetMouseIdleTimer);
    document.addEventListener('click', this.resetMouseIdleTimer);
    document.addEventListener('scroll', this.resetMouseIdleTimer);
    this.resetMouseIdleTimer();
  },
  beforeDestroy() {
    document.removeEventListener('mousemove', this.resetMouseIdleTimer);
    document.removeEventListener('keydown', this.resetMouseIdleTimer);
    document.removeEventListener('click', this.resetMouseIdleTimer);
    document.removeEventListener('scroll', this.resetMouseIdleTimer);
    if (this.mouseIdleTimer) {
      clearTimeout(this.mouseIdleTimer);
    }
  }
};
